import React from 'react'
import CollectionsRoot from '../components/pages/collections/collections-root'

const CollectionsPage=()=>{
  return(
    <CollectionsRoot />
  )
}

export default CollectionsPage